import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Box,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { auditTypes, buildDetailUrl, formatAuditDate, formatDay } from './auditLogUtils';

const rowsPerPageOptions = [25, 50, 100, 200];

// One row per order / sample / result, described by its latest snapshot. Paging is done by the server.
const AuditLogTable = ({ type, dateLabel, auditData, count, page, rowsPerPage, onChange }) => {
  const typeInfo = auditTypes[type];
  const showSample = type === 'samples' || type === 'results';
  const showResult = type === 'results';
  // order, [sample], [test code, parameter], description, [status], date, changes, last audited, actions
  const columnCount = 6 + (showSample ? 1 : 0) + (showResult ? 2 : 0) + (typeInfo.showStatus ? 1 : 0);

  const handleViewClick = (item) => {
    // The full history opens in its own tab so the list and its search stay where they are.
    window.open(buildDetailUrl(type, item), '_blank', 'noopener');
  };

  return (
    <Paper>
      <Box>
        <TableContainer sx={{ maxHeight: '65vh', overflowY: 'auto', width: '99%' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Order Number</TableCell>
                {showSample && <TableCell>Sample Number</TableCell>}
                {showResult && <TableCell>Test Code</TableCell>}
                {showResult && <TableCell>Parameter</TableCell>}
                <TableCell>{typeInfo.descriptionHeader}</TableCell>
                {typeInfo.showStatus && <TableCell>Status</TableCell>}
                <TableCell>{dateLabel}</TableCell>
                <TableCell align="right">Changes</TableCell>
                <TableCell>Last Audited</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={columnCount} align="center">
                    No audit entries found for this search.
                  </TableCell>
                </TableRow>
              )}
              {auditData.map((item) => (
                <TableRow
                  hover
                  key={`${item.orderNumber}-${item.sampleNumber}-${item.testCode}-${item.parameter}`}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleViewClick(item)}
                >
                  <TableCell>{item.orderNumber}</TableCell>
                  {showSample && <TableCell>{item.sampleNumber}</TableCell>}
                  {showResult && <TableCell>{item.testCode}</TableCell>}
                  {showResult && <TableCell>{item.parameter}</TableCell>}
                  <TableCell>{item.description}</TableCell>
                  {typeInfo.showStatus && <TableCell>{item.status}</TableCell>}
                  <TableCell>{formatDay(item.businessDate)}</TableCell>
                  <TableCell align="right">{item.changes}</TableCell>
                  <TableCell>{formatAuditDate(item.lastChange)}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      startIcon={<HistoryIcon />}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewClick(item);
                      }}
                    >
                      View history
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, newPage) => onChange(newPage, rowsPerPage)}
        onRowsPerPageChange={(e) => onChange(0, parseInt(e.target.value, 10))}
      />
    </Paper>
  );
};

export default AuditLogTable;
